<template>
  <div v-if="list.length > 0" class="community-list">
    
    <!-- <poster v-if="curIndex!==''" :curItem="list[curIndex]"  :typeId="id"></poster> -->
    <div class="list-item" v-for="(item, index) in data">
      <div class="item">
      
        <div  v-if="from!=='profile'" class="item-header">
          <div class="avatar" @click="goRoute(item.user, item.id)">
            <img class="img" :src="(item.user.authority && item.user.authority.auth_avatar) || item.user.avatar || require('assets/imgs/padom.png')" :alt="item.user.nickname"  />
          </div>
          <div class="extra-view">
            <div class="link" @click="goRoute(item.user, item.id)">{{(item.user.authority && item.user.authority.auth_nickname) ||item.user.nickname || '游客'}}</div>
            <span class="time">{{item.pub_time}}</span>
          </div>
          <button class="btn oparate-btn" @click.prevent="oparate(index, 'follow')" v-if="from == 'home' || from == 'detail'" :class=" item.followed ? 'followed-btn' : 'follow-btn'">
            {{item.followed ? '已关注':'+关注'}}
          </button>
        </div>
        <div v-if="item.isProducts"  class="item-body table-box">
          <div class="t-header pc">
            我想「{{item.content.type}}」
            <router-link class="text-btn" :to="'/detail/'+item.id + '?typeId=' + id">查看详情<i class="iconfont icon-jiantou"></i></router-link>
          </div>
          <div class="t-body">
            <div class="t-flex">
              <div class="t-l pc">产品明细</div>
              <div class="t-r pc">联系人</div>
            </div>
            <div class="t-flex">
              <div class="t-l pc">
                <div v-for="p in item.content.products" class="product">{{p.name}},{{p.price}}元/公斤，{{p.num}}公斤</div>
              </div>
              <div class="t-r pc">{{item.content.contactName}}</div>
            </div>
            <div v-if="item.content.ways.length>0" class="ways pc">
              <p v-for="w in item.content.ways">·{{w}}</p>
            </div>
          </div>
        </div>
        <div v-else class="item-body">
          <div class="cc content" :ref="'content_'+index" :id="item.id">
            <div> {{item.content.substr(0, 50) + (item.content.length > 50 ?'···':'') }}<router-link class="link-btn"  :class="item.content.length > 50 ? '' : 'mr'" :to="'/detail/'+item.id + '?typeId=' + id">查看详情<i class="iconfont icon-jiantou"></i></router-link></div>
          </div>
          <div v-if="item.mediaType == 'video'" class="media-view">
            <div class="video-box">
              <video class="video" controls :ref="'video_'+index" :src="item.album[0]" @click="pause(index)" 
              x5-playsinline 
              playsinline  
              webkit-playsinline 
              x5-video-player-type="h5-page" 
              x-webkit-airplay="true" 
              >
                您的浏览器不支持 video 标签。
              </video>
              <img v-show="index !== curIndex" class="img" :src="item.album[1]" />
              <div v-show="index !== curIndex" class="play-btn iconfont icon-bofang" @click="play(index)">
            </div>
            
            </div>
          </div>
          <div v-if="item.mediaType == 'image'"  :class="item.album.length>1 ? 'media-view2 clearfix': 'media-view'">
            <div class="media" v-for="(media, index) in item.album">
              <img  :preview="item.id" class="pic" :src="media" />
            </div> 
          </div>
        </div>
        <div v-if="item.address" class="address"><i class="sprite sprite-ditu"></i>{{item.address}}</div>
        <div v-if="from !== 'profile'" class="item-footer">
          <button class="btn" @click.prevent="oparate(index, 'zan')" :class="{em: item.is_liked}"><i class="sprite sprite-zan"></i>点赞<span>{{item.like_count}}</span></button>
          <button class="btn" @click.prevent="oparate(index, 'comment')" ><i class="sprite sprite-huifu"></i>评论{{item.comment_count}}</button>
          <!-- <router-link :to="'/comment/' + item.id + '?typeId=' + id " class="btn"><i class="sprite sprite-huifu"></i>{{item.comment_count}}</router-link> -->
          <button class="btn" @click.prevent="share(index)"><i class="sprite sprite-zhuanfa"></i>转发</button>
          <!-- <button class="btn" @click.prevent="poster(index)"><i class="sprite sprite-xiangce"></i>海报</button> -->
        </div>
        <div v-else class="item-footer">
          <span class="time">{{item.pub_time}}</span>
          <button v-if="is_it_self" class="btn2 em" @click.prevent="oparate('delete')"><i class="iconfont icon-shanchu"></i>删除</button>
        </div>
      </div>
      <div v-if="item.two_comment && item.two_comment.data.length>0" class='comment-view'>
        <div class="comment-header">回复（ {{item.two_comment.data.length}} ）<button class="btn" @click.prevent="oparate(index, 'comment')"><i class="sprite sprite-xie"></i>写评论</button></div>
        <div class="comment-body">
          <comment v-for="(comment,index) in item.two_comment.data" v-bind:key="comment.id" :index="index"  :comment="comment" :contentId="item.id"></comment>
        </div>
      </div>
    </div>
    <modal-share v-show="modalShare" @showModalShare="showModalShare"></modal-share>
  </div>
  
</template>
<script>
  
  // import Poster from 'components/poster/Poster.vue';
  import {Env} from 'utils/util.js';
  import { follow, zan, isAppOrWeixin } from 'assets/js/community.js';
  import { share } from 'assets/js/share.js';
  import ModalShare from 'components/tips/ModalShare.vue';
  // import Comment from './Comment.vue';
  import  Comment from 'components/comments/Comment.vue';
  export default {
    name: 'CommunityList',
    props: ['id', 'from', 'list', 'is_it_self', 'title'],
    data(){
      return {
        curIndex: '',
        // data: this.list,
        tip: '',
        download: true,
        imgCode: '',
        isApp: false,
        modalShare: false
      }
    },
    computed:{
      tokens(){
        return this.$store.state.tokens;
      },
      data: {
        get(){
          // let rem = parseFloat(this.getRem());
          let reg = /↵/g;
          this.list.map(item=>{
            if(/products/i.test(item.content)){
              item.content = JSON.parse(item.content);
              item.isProducts = true;
            }else if(/"content"/i.test(item.content)){
              item.content = JSON.parse(item.content);
              item.address = item.content.address;
              item.content = item.content.content;
            }
          });
          return this.list;
        },
        set(nV){
          this.list = nV;
        }
      },
      
    },
    components:{
      ModalShare,
      Comment
    },
    created(){
      Env.isCGApp() && (this.isApp = true);
      this.isApp || share({
          title: this.title,
          content: `立即点击阅读「${this.title}」详细信息。`
      });
    },
    methods:{
      async oparate(index, type){
        let that = this;
        let item = this.list[index], id='';
        let t = await isAppOrWeixin();
        if(t){
          let tokens = this.tokens || await this.$store.dispatch('cbgcAuth');
          if(tokens.status){
            this.$emit('showTip', tokens.message);
            return;
          }
          tokens = typeof tokens == 'string' ? tokens : tokens.access_token;
          
          switch(type){
            case 'follow':
              id = item.user.id;
              follow(id,tokens).then(res=>{
                that.list[index].followed = res.data.followed;
              });
            break;
            case 'zan':
              id = item.id;
              zan(id, tokens).then(res=>{
                that.list[index].is_liked = res.data.is_liked;
                that.list[index].like_count = res.data.like_count;
              });
            break;
            case 'comment':
              this.$router.push({
                name: 'Comment',
                params: {
                  id: item.id
                },
                query:{
                  typeId: this.id
                }
              });
            break;
          }
        }else{
          this.$emit('showTip', '请在川观新闻客户端或者微信参与互动');
        }
        
      },
      share(index){
        this.modalShare = !this.isApp;
        let item = this.list[index];
        let content = item.content.content || item.content;
        (content.length > 38) && (content = content.substr(0, 38) + '···');
        share({
          title: this.title,
          content: content,
          imgUrl: item.album.length && item.album[0] && (/mp4/i.test(item.album[0]) ? item.album[1] : item.album[0]),
          link: `https://h5.chuanbaoguancha.cn/community/detail/${item.id}?typeId=${this.id}`
        });
      },
      showModalShare(status){
        this.modalShare = status;
      },
      async goRoute(user, cid){
        let t = await isAppOrWeixin();
        if(t){
          this.$router.push({
            name: 'Profile',
            params: {
              id: user.id
            },
            query:{
              contentId: this.id,
              nickname: user.nickname,
              avatar: user.avatar,
              is_authority: user.is_authority
            }
          });
        }else{
          this.$emit('showTip', '请在川观新闻客户端或者微信参与互动');
        }
      },
      play(index){
        this.curIndex!=='' &&  this.$refs['video_'+this.curIndex][0].pause();
        this.$refs['video_'+index][0].play();
        this.curIndex = index;
      },
      pause(index){
        this.$refs['video_'+index][0].pause();
        this.curIndex = '';
      },
      getRem(){
        const defaultRem = 14;
        let winWidth = window.innerWidth;
        let rem = winWidth / 375 * defaultRem;
        return rem;
      }
    },
    watch:{
      list:{
        handler(nV, oV){
         this.data = nV;
          console.log('watch data: ',this.data);
        },
        deep:true
      },
    }
  }
</script>
<style lang="scss">
  
  .list-item{
    padding: 3.33vw 3.33vw 3vw;
    margin-bottom: .5em;
    background-color: #fff;
  }
  .link-btn{
    display: inline-block;
    color: #2f78f2;
    position: relative;
    margin-left: .4em;
    .iconfont{
      font-size: .6em;
      position: relative;
      top: -.1em;
      &:before{
        font-weight: 900;
      }
    }
  }
  .table-box{
    border: 1px solid #ddd;
    margin-bottom: .5em;
    .pc{
      padding: .5em .5em;
    }
    .t-header{
      position: relative;
      color: #0c8918;
      font-weight: 700;
      .text-btn{
        display: block;
        position: absolute;
        font-size: .9em;
        font-weight: 400;
        color: #333;
        right: .5em;
        left: auto;
        top: 50%;

        transform: translateY(-50%);
        .iconfont{
          font-size: .8em;
          position: relative;
          /* top: -.03em; */
        }
      }
      
    }
    .ways{
      border-top: 1px solid #ddd;
    }
    .t-flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #ddd;
      &:nth-child(1){
        .t-l, .t-r{
          text-align: center;
          font-weight: 700;
        }
        
      }
      .t-l, .t-r{
        box-sizing: border-box;
        
      }
      .t-l{
        width: 70%;
        border-right: 1px solid #ddd;
      }
      .t-r{
        width: 30%;
        text-align: center;
      }
    }
    .product{
      border-top: 1px solid #eee;
      line-height: 1.2;
      padding: .3em 0;
      &:nth-child(1){
        border-top: 0 none;
      }
    }
  }
  pre{
    white-space: pre-line;
    margin-top: 0;
  }
  .cc{
    display: block;
    cursor: pointer;
    position: relative;
    z-index: 10;
    span{
      color: #576b95;
    }
  }
 
  .item-header{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    margin-bottom: .6em;
    
    .btn{
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      .em{
        color: #da251d;
      }
    }
    .oparate-btn{
      width: 18.6vw;
      height: 8vw;
      border-radius: 8vw;
      background-color: #ffeeee;
      color: #e65757;
      font-weight: 700;
    }
    .followed-btn{
      background-color: #eff3f7;
      color: #aab5c4;
    }
    
  }
  
  .extra-view{
    .link,.time{
      display: block;
    }
    .link{

    }
    .time{
      color: #7e8998;
      font-size: .857em;
    }
  }
  .oparate{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .item-body{
    margin-top: .3em;
    font-size: 1.143em;
    line-height: 1.5;
    .content{
      /* display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      line-height: 1.5;
      max-height: 6.2em; */
      white-space: pre-wrap;
    }
  }
  .media-view{
    margin: .5em auto .5em;
    overflow: hidden;
    position: relative;
    max-width: 100%;
    max-height: 250px;
    .media, .video, .video+.img{
      max-width: 100%;
      max-height: 250px;
    }
    .img{
      width: 100%;
      position: absolute;
      left:0;top:0;
      z-index: 1;
    }
    .pic{
      max-width: 100%;
      max-height: 250px;
    }
    .media{
      /* width: 100%; */
    }
    .video-box{
      display: inline-block;
      position: relative;
    }
    .video + .img{
      /* width: 100%; */
      width: auto;
    }
    .play-btn{
      position: absolute;
      left: 50%;top:50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      font-size: 3.6em;
      color: #da251d;
    }
  }
  .media-view2{
    margin: .5em auto .5em;
    .media{ 
      display: block;
      float: left;
      margin: 0;padding:0;
      width: 30vw;
      height: 30vw;
      overflow: hidden;
      margin: 0 1.3vw 1.3vw 0;
      border: 1px solid #ecf2f5;
      box-sizing: border-box;
      position: relative;
      &:nth-child(3n+3){
        margin-right: 0;
      }
      .pic{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  /* .imgs{
    .img{
      display: inline-block;
      width: 25vw;
      height: 25vw;
      margin: .4em .7em 0 0;
    }
  } */
  .video-view{
    video{
      width: 100%;
    }
  }
  .address{
    /* padding: .4em  0 0 0; */
    color: #7e8998;
    font-size: .857em;
    /* border-top: 1px solid #eee; */
  }
  .item-footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    border-top: 1px solid #ecf2f5;
    padding-top: .9em;
    margin-top: .8em;
    .btn{
      flex: 1;
      line-height: 2;
      span{
        display: inline-block;
        font-size: 1.1em;
      }
    }
    
  }
  .comment-view{
    margin-top: .5em;
    background-color: #eff3f7;
    border-radius: .2em;
    padding: .5em 1em .3em;
  }
  .comment-header{
    position: relative;
    padding: .5em 0;
    border-bottom: 1px solid #dbe3e8;
    .btn{
      position: absolute;
      right: 1em;
      top: 50%;
      transform: translateY(-50%);
    }    
  }

</style>